// data/projects.js
import HeroImage from '../assets/images/hero.webp';
import CrmImage from '../assets/images/Crm.webp';
import DrPerformanceImage from '../assets/images/dr-performance.webp';
import ScholarShipImage from '../assets/images/Scholarship.webp';
import ConsultantsPageImage from '../assets/images/project-consultantspage.webp';
import ApnaAshiyanaImage from '../assets/images/project-apnaashiyana.webp';
import CrmEuroworldImage from '../assets/images/project-crmeuroworld.webp';
import EuroworldEducationImage from '../assets/images/project-euroworldeducation.webp';
import NexfleetImage from '../assets/images/project-nexfleet.webp';
import DaehanskavaImage from '../assets/images/project-daehanskava.webp';
import DaehanLinksImage from '../assets/images/project-daehanlinks.webp';
import OsyImage from '../assets/images/project-osy.webp';
import TechificentImage from '../assets/images/team/project-techificent.webp';
import SyedShayanImage from '../assets/images/team/project-syedshayan.webp';
import BookTicketPkImage from '../assets/images/team/project-bookticketpk.webp';
import NasonasImage from '../assets/images/team/project-nasonas.webp';

const projects = [
  {
    slug: 'consultants-page',
    title: 'Consultants Page - SaaS CRM',
    category: 'SaaS',
    description: 'Multi-tenant SaaS CRM for education & immigration consultancies with subscription billing, free trial and branch-level access control',
    overview: 'Consultants Page transformed a single-company CRM into a full multi-tenant SaaS platform for education and immigration consultancies. Every company gets an isolated workspace with its own branches, employees, students and billing, backed by 80+ database tables and 120+ API endpoints.',
    features: [
      'Self-service registration with a 7-day free trial',
      'Subscription billing through Paddle and Stripe, plus bank transfer payments with admin approval',
      'Automated renewal reminders and subscription expiry enforcement',
      'Plan-based usage limits for employees, branches, students, leads and invoices',
      'Role, department and branch-level access control',
      'Student management, university applications, social media leads, invoicing, expenses, attendance and leave workflows',
      '143 automated tests including cross-tenant access control tests',
    ],
    results: ['80+ database tables', '120+ API endpoints', '30+ security issues resolved'],
    image: ConsultantsPageImage,
    technologies: ['Next.js', 'TypeScript', 'MySQL', 'Redux Toolkit', 'Stripe', 'Paddle', 'Vitest'],
    location: 'Lahore, Pakistan',
    year: '2026',
    liveUrl: 'https://consultantspage.com/',
  },
  {
    slug: 'apna-ashiyana',
    title: 'Apna Ashiyana - Real Estate',
    category: 'Real Estate',
    description: 'Real estate marketplace and multi-tenant CRM with property search, interactive maps, agency portal and social media auto-publishing',
    overview: 'Apna Ashiyana is a real estate marketplace and multi-tenant SaaS CRM made up of a public property listing website, an agency/agent portal and an admin dashboard. It covers the complete journey from property request to negotiation, deal and invoice.',
    features: [
      'Subscription-based module access with role and location-based permissions',
      'Property request, negotiation, deal and invoicing workflow',
      'Advanced property search with typo tolerance',
      'SEO with dynamic sitemaps and Incremental Static Regeneration (ISR)',
      'Interactive property maps built with Leaflet',
      'Automated listing and video publishing to Facebook, Instagram and TikTok',
      'Scheduled Lead Ads synchronization with cron jobs and encrypted access tokens',
    ],
    results: ['Public website + agent portal + admin', 'Auto social publishing', 'SEO-ready with ISR'],
    image: ApnaAshiyanaImage,
    technologies: ['Next.js', 'React', 'TypeScript', 'MySQL', 'Redux Toolkit', 'Leaflet'],
    location: 'Lahore, Pakistan',
    year: '2026',
    liveUrl: 'https://apnaashiyana.pk/',
  },
  {
    slug: 'euroworld-crm',
    title: 'EuroWorld CRM',
    category: 'CRM',
    description: '35+ module CRM for an education consultancy covering leads, applications, invoicing, HR, real-time chat and Lead Ads integration',
    overview: 'A 35+ module CRM built for EuroWorld Education Consultants that manages the whole consultancy from first lead to student registration, university applications, invoicing, HR and financial audits.',
    features: [
      'Lead management, student registrations and university applications',
      'JWT authentication with department and user-level RBAC across 40+ API routes',
      'Facebook, Instagram and TikTok Lead Ads with custom field mapping',
      'AES-256 encrypted token storage',
      'Real-time chat and automated email notifications',
      'S3 and Cloudinary file uploads, Excel import/export',
      'Interactive Recharts dashboards',
    ],
    results: ['35+ modules', '40+ secured API routes', '3 Lead Ads integrations'],
    image: CrmEuroworldImage,
    technologies: ['Next.js', 'React', 'TypeScript', 'MySQL', 'Redux', 'AWS S3'],
    location: 'Karachi, Pakistan',
    year: '2026',
    liveUrl: 'https://crmeuroworld.com/',
  },
  {
    slug: 'euroworld-education',
    title: 'EuroWorld Education',
    category: 'Education',
    description: 'Study-in-Europe consultancy website with destinations, scholarships, success stories and free consultation booking',
    overview: 'The public website for EuroWorld Education Consultants, helping students explore study destinations in Europe, find scholarships and book a free consultation. Leads from the website flow directly into the EuroWorld CRM.',
    features: [
      'Destination and scholarship pages',
      'Success stories and news & updates sections',
      'Free consultation lead form',
      'WhatsApp and call quick-contact buttons',
      'SEO-friendly, fully responsive layout',
    ],
    results: ['Connected to EuroWorld CRM', 'Mobile-first design'],
    image: EuroworldEducationImage,
    technologies: ['Next.js', 'React', 'TypeScript', 'SEO'],
    location: 'Karachi, Pakistan',
    year: '2026',
    liveUrl: 'https://www.euroworldeducation.com/',
  },
  {
    slug: 'nexfleet',
    title: 'Nexfleet - Vehicle Tracking',
    category: 'Web Application',
    description: 'Multi-vendor fleet management platform with complaint lifecycle, automated invoicing, PDF exports and analytics dashboards',
    overview: 'Nexfleet is a multi-vendor vehicle tracking dashboard and management platform for a South African fleet compliance company. It centralizes fleet, driver and operational data in a single platform.',
    features: [
      'Role-based permissions with module-level CRUD for employees',
      'Complaint lifecycle with file uploads, status tracking, assignment and audit trail',
      'Automated invoicing with dynamic billing and payment tracking',
      'PDF generation and export engine',
      'Bar, line and pie charts for utilization, complaints, vendor performance and revenue',
      'Secure file uploads and fast data rendering',
    ],
    results: ['Multi-vendor fleet data in one place', 'Automated billing'],
    image: NexfleetImage,
    technologies: ['Next.js', 'React', 'MySQL', 'Charts', 'PDF Export'],
    location: 'South Africa',
    year: '2026',
    liveUrl: 'https://nexfleet.org/',
  },
  {
    slug: 'daehanskava',
    title: 'Daehanskava - Study Abroad CRM',
    category: 'CRM',
    description: 'Study abroad CRM with student lifecycle tracking, university management, attendance, invoicing and performance analytics',
    overview: 'A study abroad consultancy CRM that tracks every student from application submission to visa approval, along with university credentials, staff attendance and employee performance.',
    features: [
      'Module-wise CRUD permissions for every employee',
      'Student lifecycle from application to visa approval with document uploads',
      'University management with Gmail communication logs, deadlines, fees and scholarships',
      'Employee attendance, leave workflows and performance evaluation',
      'Automated invoicing, expense tracking and PDF reports',
      'Dashboard analytics and deadline/task reminder notifications',
    ],
    results: ['End-to-end student tracking', 'Staff performance insights'],
    image: DaehanskavaImage,
    technologies: ['React', 'Node.js', 'MySQL', 'RBAC'],
    location: 'Lahore, Pakistan',
    year: '2026',
    liveUrl: 'https://daehanskava.com/',
  },
  {
    slug: 'daehan-links',
    title: 'Daehan Links - Study in Korea',
    category: 'Education',
    description: 'Education consultancy website helping students study in South Korea with services, blogs and partner institutions',
    overview: 'The public website for Daehan Links, an education consultancy that specializes in helping students study in South Korea, from choosing a university to getting a student visa.',
    features: [
      'Services, partner institutions and testimonials pages',
      'Blog for study-in-Korea guides',
      'Free consultation booking',
      'Social media and WhatsApp integration',
      'Responsive, SEO-friendly pages',
    ],
    results: ['Lead generation for the consultancy'],
    image: DaehanLinksImage,
    technologies: ['Next.js', 'React', 'Responsive Design', 'SEO'],
    location: 'Lahore, Pakistan',
    year: '2026',
    liveUrl: 'https://daehanlinks.kr/',
  },
  {
    slug: 'osy-solutions',
    title: 'OSY Solutions',
    category: 'Business',
    description: 'Swiss employer-of-record platform for hiring abroad, covering recruitment, payroll and administration',
    overview: 'Website for OSY, a Swiss company that recruits employees abroad and handles hiring, payroll, office infrastructure and administration for its clients.',
    features: [
      'Pixel-perfect responsive interface',
      'Interactive sliders, modals and tabs',
      'Savings calculator and consultation booking',
      'Performance optimization with lazy loading and minification',
      'Cross-browser and mobile tested',
    ],
    results: ['Fast, responsive corporate site'],
    image: OsyImage,
    technologies: ['HTML', 'SCSS', 'JavaScript', 'jQuery', 'Bootstrap'],
    location: 'Switzerland',
    year: '2023',
    liveUrl: 'https://osy.ch/',
  },
  {
    slug: 'universities-page',
    title: 'UniversitiesPage.com',
    category: 'Education',
    description: 'Study-abroad portal helping students explore global higher-education opportunities with AI integration',
    overview: 'A study-abroad portal that helps students explore universities and programs worldwide, with AI-powered guidance.',
    features: [
      'University and program search',
      'AI integration with the DeepSeek API',
      'Responsive React frontend',
      'Laravel REST APIs with role-based access control',
    ],
    image: HeroImage,
    technologies: ['Next.js', 'Node.js', 'DeepSeek API', 'React'],
    location: 'Lahore, Pakistan',
    year: '2024',
    liveUrl: 'https://universitiespage.com',
  },
  {
    slug: 'student-application-crm',
    title: 'Student Application CRM System',
    category: 'CRM',
    description: 'Custom CRM for managing complete student application lifecycle with role-based permissions',
    overview: 'A custom CRM for managing the complete student application lifecycle, from lead to enrolment, with role-based permissions for staff.',
    features: [
      'Student application lifecycle management',
      'Role-based permissions',
      'Document uploads and notifications',
      'Token-based authentication with Laravel Sanctum',
    ],
    image: CrmImage,
    technologies: ['React.js', 'Laravel', 'MySQL', 'REST API'],
    location: 'Lahore, Pakistan',
    year: '2024',
    liveUrl: 'https://crm-universitiespage.com/',
  },
  {
    slug: 'dr-performance',
    title: 'DR Performance - Auto Repair',
    category: 'E-commerce',
    description: 'Automotive service & tuning platform with eCommerce cart and Stripe payment integration',
    overview: 'An automotive service and tuning platform for a German workshop, with an online shop and Stripe checkout.',
    features: ['Service and tuning catalogue', 'eCommerce cart', 'Stripe payment integration', 'Responsive design'],
    image: DrPerformanceImage,
    technologies: ['Laravel', 'PHP', 'MySQL', 'Stripe'],
    year: '2023',
    liveUrl: 'https://dr-performance.de',
  },
  {
    slug: 'techificent',
    title: 'Techificent - Software Company',
    category: 'Business',
    description: 'Software company portfolio website with services showcase and digital transformation solutions',
    overview: 'Portfolio website for a software company showcasing its services and digital transformation solutions.',
    features: ['Services showcase', 'SSR/SSG for performance', 'Responsive design'],
    image: TechificentImage,
    technologies: ['Next.js', 'Node.js', 'SSR/SSG', 'Responsive Design'],
    location: 'Lahore, Pakistan',
    year: '2021',
    liveUrl: 'https://techificent.com',
  },
  {
    slug: 'syedshayan',
    title: 'SyedShayan - Real Estate',
    category: 'Real Estate',
    description: 'Comprehensive real estate platform for property listings (rent/sale) with categorized browsing',
    overview: 'A real estate platform for property listings for rent and sale, with categorized browsing.',
    features: ['Rent and sale listings', 'Categorized browsing', 'Blade component UI', 'Admin management'],
    image: SyedShayanImage,
    technologies: ['Laravel', 'PHP', 'MySQL', 'Blade Templates'],
    location: 'Lahore, Pakistan',
    year: '2023',
    liveUrl: 'https://syedshayan.com/Home',
  },
  {
    slug: 'bookticketpk',
    title: 'BookTicketPK - Airline Booking',
    category: 'Travel',
    description: 'Full-featured airline ticket booking platform with real-time flight search and booking',
    overview: 'An airline ticket booking platform with real-time flight search and booking through airline APIs.',
    features: ['Real-time flight search', 'Online booking', 'Airline API integration', 'Responsive Bootstrap UI'],
    image: BookTicketPkImage,
    technologies: ['Laravel', 'PHP', 'MySQL', 'Bootstrap', 'Airline APIs'],
    liveUrl: 'https://www.bookticketpk.com',
  },
  {
    slug: 'virtual-scholarship-center',
    title: 'Virtual Scholarship Center',
    category: 'Education',
    description: 'Online scholarship and college funding platform helping students find financial aid and manage applications',
    overview: 'An online scholarship and college funding platform that helps students find financial aid and manage their applications.',
    features: ['Scholarship search', 'Application management', 'Student accounts'],
    image: ScholarShipImage,
    technologies: ['HTML', 'CSS', 'JavaScript', 'Laravel', 'MySQL'],
    liveUrl: 'https://virtualscholarshipcenter.com/',
  },
  {
    slug: 'nasonas',
    title: 'Nasonas - Job Portal Platform',
    category: 'Job Portal',
    description: 'Complete job portal system for employers and candidates with job posting, applications, and admin management',
    overview: 'A complete job portal for employers and candidates with job posting, applications and admin management.',
    features: ['Employer and candidate accounts', 'Job posting and applications', 'Admin management panel'],
    image: NasonasImage,
    technologies: ['HTML', 'CSS', 'JavaScript', 'Laravel', 'MySQL'],
    year: '2023',
    liveUrl: 'https://nasonas.com/',
  },
];

export const getProjectBySlug = (slug) => projects.find((project) => project.slug === slug);

export default projects;
